import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false,
  eventTypeById: null,
  loadingById: false,
};


export default function structural_divisions(state = initialState, action) {
  switch (action.type) {
    case types.GET_STRUCTURAL_DIVISIONS:
      return {
        ...state,
        structuralDivisionsList: action.payload
      };

    default:
      return state;
  }
}